export enum CrmEventAttendingStatus {
	Yes = 0,
	No = 10,
	Maybe = 20,
}
